module.exports = __webpack_public_path__ + "img/amazon-22px.bdf4e545.png";